module.exports = __webpack_public_path__ + "static/media/sy.892e181c.svg";